import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// MUI theme for the dashboard
const theme = createTheme({
  palette: {
    primary: {
      main: '#34495e', // Main header background
    },
    secondary: {
      main: '#27ae60', // Healthy status (used in circles)
    },
  },
  typography: {
    fontFamily: ['Roboto', 'Open Sans', 'sans-serif'].join(','),
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        {/* resets the browser's default margins and paddings */}
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);